import React from "react";
import { Box, Typography, Button, Chip } from "@mui/material";
import { CompareArrows as CompareIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import HomeSection from "./HomeSection";
import { colors } from "../../theme";
import {
  BRAND_COLORS,
  brandFilledButtonSx,
  brandRgba,
} from "../../utils/brandAssets";

const PRESET_MATCHUPS = [
  {
    label: "Aaron vs Bonds",
    players: ["aaronha01", "bondsba01"],
  },
  {
    label: "Ruth vs Mays",
    players: ["ruthba01", "mayswi01"],
  },
  {
    label: "Judge vs Ohtani",
    players: ["judgeaa01", "ohtansh01"],
  },
  {
    label: "Griffey vs Rodriguez",
    players: ["griffke02", "rodrial01"],
  },
];

const CompareSpotlight = () => {
  const navigate = useNavigate();

  const goToCompare = (playerIds = []) => {
    const params =
      playerIds.length > 0 ? `?players=${playerIds.join(",")}` : "";
    navigate(`/app/compare${params}`);
  };

  return (
    <HomeSection
      title="Compare players"
      subtitle="Side-by-side stats settle the argument"
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "stretch", sm: "center" },
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
            Pick any two legends — career totals, season charts, and head-to-head
            numbers to back up your take.
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {PRESET_MATCHUPS.map(({ label, players }) => (
              <Chip
                key={label}
                label={label}
                clickable
                variant="outlined"
                onClick={() => goToCompare(players)}
                sx={{
                  borderColor: colors.border,
                  "&:hover": {
                    borderColor: BRAND_COLORS.cyan,
                    backgroundColor: brandRgba(BRAND_COLORS.cyan, 0.08),
                  },
                }}
              />
            ))}
          </Box>
        </Box>
        <Button
          variant="contained"
          size="large"
          startIcon={<CompareIcon />}
          onClick={() => goToCompare()}
          sx={{ flexShrink: 0, px: 3, ...brandFilledButtonSx }}
        >
          Compare players
        </Button>
      </Box>
    </HomeSection>
  );
};

export default CompareSpotlight;
